
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function Logo({ className }: { className?: string }) {
  return (
    <Link to="/" className="flex-shrink-0">
      <img 
        alt="Everest Auto Solutions" 
        className={cn("h-10 w-auto", className)} 
        src="/lovable-uploads/f6c76b7e-f9e5-4461-8247-54808a0b2970.png" 
      />
    </Link>
  );
}
